import { combineReducers } from 'redux';

import offersReducer from 'src/app/redux/reducers/offersReducer';
import feedbackMessageReducer from 'src/app/redux/reducers/feedbackMessageReducer';
import authorizeReducer from 'src/app/redux/reducers/authorizeReducer';
import transclusionReducer from 'src/app/redux/reducers/transclusionReducer';
import resetReducers from 'src/app/redux/reducers/reset';
import loginReducers from 'src/app/redux/reducers/login';
import registrationReducers from 'src/app/redux/reducers/registration';


export default combineReducers({
  ...resetReducers,
  ...loginReducers,
  ...registrationReducers,
  offersReducer,
  feedbackMessageReducer,
  transclusionReducer,
  authorizeReducer
});
